/**
 * Closes the modal.
 */
const close = (
  focusedElementBeforeMenu: HTMLElement|null,
  mobileMenu: HTMLElement,
  menuOverlay: HTMLElement,
  menuToggle: HTMLElement
) => {
  mobileMenu.classList.add( 'is-closed' )
  menuToggle.setAttribute( 'aria-expanded', 'false' )
  mobileMenu.setAttribute( 'aria-hidden', 'true' )
  menuOverlay.style.display = 'none'
  setTimeout( () => mobileMenu.setAttribute( 'data-menu-closed', 'true' ), 150 )
  if ( focusedElementBeforeMenu ) focusedElementBeforeMenu.focus()
}

export default close
